import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { projectBySlugQueryOptions } from '@/entities/project'
import { useSession } from '@/entities/session'
import type { Crumb } from '@/shared/ui/breadcrumb'
import { DOC_TABS, DocumentPageView } from '../-ui/document-page'

const DocSearchSchema = z.object({
  tab: z.enum(DOC_TABS).optional().catch(undefined),
})

export const Route = createFileRoute('/_app/$company/$project_/documents/$doc')({
  validateSearch: (search) => DocSearchSchema.parse(search),
  head: () => ({ meta: [{ title: 'Документ · STIT Deal' }] }),
  component: DocumentPage,
})

function DocumentPage() {
  const { company, project, doc } = Route.useParams()
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()
  const { session } = useSession()
  const isEmployee = session?.kind === 'employee'

  const projectQ = useQuery(projectBySlugQueryOptions(company, project))
  const d = projectQ.data

  const ancestors: Crumb[] = [
    isEmployee
      ? { label: d?.company_name ?? company, to: '/companies/$company', params: { company } }
      : { label: d?.company_name ?? company },
    { label: d?.title ?? project, to: '/$company/$project', params: { company, project } },
    {
      label: 'Документы',
      to: '/$company/$project',
      params: { company, project },
      search: { tab: 'docs' },
    },
  ]

  return (
    <DocumentPageView
      documentId={doc}
      breadcrumbAncestors={ancestors}
      activeTab={tab ?? 'file'}
      onTabChange={(value) => void navigate({ search: { tab: value } })}
      onDeleted={() =>
        void navigate({
          to: '/$company/$project',
          params: { company, project },
          search: { tab: 'docs' },
        })
      }
    />
  )
}
